import angular from 'angular'

import modalDetailCtrl from './modalDetailCtrl'
import manualContactModal from './manualContactModal'
import fullEleInvoiceChooseUkeyModal from './fullEleInvoiceChooseUkeyModal'
import riskWarningModalCtrl from './riskWarningModal'
import invoiceTitleModalCtrl from '../../fillOpenManage/invoice1/invoiceTitleModalCtrl'


const listPage = require('./view/list.html')
const listCtrl = require('./list')

const detailPage = require('./view/detail.html')
const realEstateDetailPage = require('./view/realEstateDetail.html')
const constructionDetailPage = require('./view/constructionDetail.html')

const editPage = require('./view/edit.html')
const editCtrl = require('./edit')

const relatedBillPage = require('../../fillOpenManage/invoice1/view/relatedBill_invoice.html')

const checkBillDetailCtrl = require('../../fillOpenManage/ovatBill/view/checkBillDetailCtrl.html')

function configRouter($stateProvider) {
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice', {
        url: '/fullEleInvoice',
        abstract: true,
        template: '<div ui-view></div>',
        default: 'outputManage.fullElectricInvoice.fullEleInvoice.list',
        title: '电子票开具',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.list', {
        url: '/list',
        template: listPage,
        controller: 'fullElectricInvoiceListCtrl',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.detail', {
        url: '/detail/:invoiceId/:invType',
        template: detailPage,
        controller: 'fullElectricInvoiceEditCtrl',
        title: '电子票详情',
        params: {
            detailFlag: true,
        },
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.realEstateDetail', {
        url: '/realEstateDetail/:invoiceId/:invType',
        template: realEstateDetailPage,
        controller: 'fullElectricInvoiceEditCtrl',
        title: '电子票详情',
        params: {
            detailFlag: true,
        },
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.constructionDetail', {
        url: '/constructionDetail/:invoiceId/:invType',
        template: constructionDetailPage,
        controller: 'fullElectricInvoiceEditCtrl',
        title: '电子票详情',
        params: {
            detailFlag: true,
        },
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.edit', {
        url: '/eidt/:invoiceId/:invType',
        template: editPage,
        controller: 'fullElectricInvoiceEditCtrl',
        title: '编辑全电票',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.add', {
        url: '/add/:invType',
        template: editPage,
        controller: 'fullElectricInvoiceEditCtrl',
        title: '新增全电票',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.addred', {
        url: '/addred/:invType',
        template: editPage,
        controller: 'fullElectricInvoiceEditCtrl',
        title: '新增红字电子票',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.relatedBill', {
        url: '/relatedBill/:waitId',
        template: relatedBillPage,
        controller: 'invRelatedBillCtrl',
        title: '电子票销售单',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoice.checkBillDetail', {
        url: '/checkBillDetail/:billId',
        template: checkBillDetailCtrl,
        controller: 'checkBillDetailCtrl',
        title: '销售单明细',
    })
}

export default angular
    .module('outputManage.fullElectricInvoice.fullEleInvoice', [])
    .config(['$stateProvider', configRouter])
    .controller('fullElectricInvoiceListCtrl', listCtrl.default)
    .controller('fullElectricInvoiceEditCtrl', editCtrl.default)
    .controller('modalDetailCtrl', modalDetailCtrl)
    .controller('invoiceTitleModalCtrl', invoiceTitleModalCtrl)
    .controller('manualContactModal', manualContactModal)
    .controller('riskWarningModalCtrl', riskWarningModalCtrl)
    .controller('fullEleInvoiceChooseUkeyModal', fullEleInvoiceChooseUkeyModal).name



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoice/index.js